import { isSignupRunningProxy } from '@bingads-webui-campaign-react/pmax-language-country';

import { websiteSchema } from './validation-schema';

// Lightweight standalone check reusing the same schema constraints WebsiteInput's
// ValidationGroup enforces, for callers (early shell) that can't render the full HOC.
// Returns the failing constraint's key (matching websiteValidationErrors in consts.js),
// or null when valid.
export const getWebsiteUrlError = (value) => {
  const { required, maxLength, pattern } = websiteSchema.properties.website;
  if (required && !value) { return 'required'; }
  if (maxLength && value.length > maxLength) { return 'maxLength'; }
  if (pattern && !pattern.test(value)) { return 'pattern'; }
  return null;
};

export const isWebsiteUrlValid = value => !getWebsiteUrlError(value);

export const isBusinessInfoValid = (bizInfoData) => {
  const isDebugging = isSignupRunningProxy();
  const {
    email,
    phoneNumber,
    callingCode,
    callingCountryCode,
    countryCode,
    websiteUrl: url,
    businessName: name,
    terms = {},
    isPoliticalAdsConfirmed,
  } = bizInfoData || {};

  if (
    (!isDebugging && !terms.accepted)
    || !phoneNumber || !callingCode || !callingCountryCode || !email
    || !countryCode || !name
    || !url
    || !isPoliticalAdsConfirmed
  ) {
    return false;
  }

  return true;
};
